import { ArrowLeft } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

export interface InlineDocumentItem {
  id: string;
  name: string;
  type: string;
  date: string;
  content: string | null;
  source: 'generated' | 'uploaded';
}

interface InlineDocumentViewerProps {
  item: InlineDocumentItem;
  onBack: () => void;
}

export function InlineDocumentViewer({ item, onBack }: InlineDocumentViewerProps) {
  return (
    <div className="space-y-3">
      <Button
        variant="ghost"
        size="sm"
        className="h-7 gap-1 text-xs"
        onClick={onBack}
      >
        <ArrowLeft className="h-3.5 w-3.5" />
        Back to list
      </Button>

      <div>
        <h3 className="text-sm font-medium">{item.name}</h3>
        <p className="text-xs text-muted-foreground">
          {new Date(item.date).toLocaleDateString()}
        </p>
      </div>

      <Card>
        <CardContent className="p-3">
          {item.content ? (
            <div className="prose prose-sm max-w-none whitespace-pre-wrap text-xs">
              {item.content}
            </div>
          ) : (
            <p className="text-sm text-muted-foreground">
              No content available for this document.
            </p>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
